import { OfferFooterConditionsItem } from './offers-footer-conditions-item';

interface OfferFooterConditionsProps {
    bonusReadonly: boolean;
    termsOfDeliveryReadonly: boolean;
    termsOfPaymentReadonly: boolean;
}

export const OfferFooterConditions = (props: OfferFooterConditionsProps) => {
    const { bonusReadonly, termsOfDeliveryReadonly, termsOfPaymentReadonly } = props;

    return (
        <div>
            <OfferFooterConditionsItem
                titleId="app.label.deliveryConditions"
                fieldName="termsOfDelivery"
                readonly={termsOfDeliveryReadonly}
            />
            <OfferFooterConditionsItem
                titleId="app.label.paymentConditions"
                fieldName="termsOfPayment"
                readonly={termsOfPaymentReadonly}
            />
            <OfferFooterConditionsItem
                titleId="app.label.poolBonus"
                fieldName="supplierBonus"
                readonly={bonusReadonly}
            />
        </div>
    );
};
